export default function (urlString) {
  const prefix = process && process.env.APP_ENV === 'local' ? 'http' : 'https';
  if (urlString.includes('http')) {
    return urlString;
  }
  return `${prefix}://${urlString}`;
}
